<template>
    <div class="week-season-comparison">
        <h2>Season to Date</h2>
        <div class="comparison">
            <div class="last-season-to-date">
                <h3>Last Season to Date</h3>
                <span class="season-to-date-gross">
                    <thin-line-pie-chart
                        :percentage="this.week.stats.last_season.gross_potential_percentage_season_to_date / 100"
                    />
                    <span class="subtext data-set-label">Gross</span>
                    {{ this.week.stats.last_season.gross_season_to_date / 100 | moneyRounded }}
                </span>

                <span class="season-to-date-attendance">
                    <thin-line-pie-chart
                        :percentage="this.week.stats.last_season.capacity_percentage_season_to_date / 100"
                    />
                    <span class="subtext data-set-label">Attendance</span>
                    {{ this.week.stats.last_season.attendance_season_to_date | commaNumber }}
                </span>

                <span class="season-to-date-playing-weeks">
                    <span class="subtext data-set-label">Playing Weeks</span>
                    {{ this.week.stats.last_season.playing_weeks_season_to_date | commaNumber }}
                </span>
            </div>
            <div class="vs">
                <span>vs</span>
            </div>
            <div class="this-season-to-date">
                <h3>This Season to Date</h3>
                <span class="season-to-date-gross">
                    <thin-line-pie-chart
                        :percentage="
                            this.week.stats.this_week
                                .gross_potential_percentage_season_to_date / 100
                        "
                    />

                    <span class="subtext data-set-label">Gross</span>
                    {{
                        (this.week.stats.this_week.gross_season_to_date / 100)
                            | moneyRounded
                    }}
                    <span
                        v-if="
                            this.week.stats.this_week
                                .gross_season_diff_percentage !== 0
                        "
                        class="subtext"
                        :class="{
                            'diff-positive':
                                this.week.stats.this_week
                                    .gross_season_diff_percentage >= 0,
                            'diff-negative':
                                this.week.stats.this_week
                                    .gross_season_diff_percentage < 0,
                        }"
                        >{{
                            this.week.stats.this_week
                                .gross_season_diff_percentage / 100
                        }}%</span
                    >
                </span>

                <span class="season-to-date-attendance">
                    <thin-line-pie-chart
                        :percentage="
                            this.week.stats.this_week
                                .capacity_percentage_season_to_date / 100
                        "
                    />
                    <span class="subtext data-set-label">Attendance</span>
                    {{
                        this.week.stats.this_week.attendance_season_to_date
                            | commaNumber
                    }}
                    <span
                        v-if="
                            this.week.stats.this_week
                                .attendance_season_diff_percentage !== 0
                        "
                        class="subtext"
                        :class="{
                            'diff-positive':
                                this.week.stats.this_week
                                    .attendance_season_diff_percentage >= 0,
                            'diff-negative':
                                this.week.stats.this_week
                                    .attendance_season_diff_percentage < 0,
                        }"
                        >{{
                            this.week.stats.this_week
                                .attendance_season_diff_percentage / 100
                        }}%</span
                    >
                </span>

                <span class="season-to-date-playing-weeks">
                    <span class="subtext data-set-label">Playing Weeks</span>
                    {{
                        this.week.stats.this_week.playing_weeks_season_to_date
                            | commaNumber
                    }}
                    <span
                        v-if="
                            this.week.stats.this_week
                                .playing_weeks_season_diff_percentage !== 0
                        "
                        class="subtext"
                        :class="{
                            'diff-positive':
                                this.week.stats.this_week
                                    .playing_weeks_season_diff_percentage >= 0,
                            'diff-negative':
                                this.week.stats.this_week
                                    .playing_weeks_season_diff_percentage < 0,
                        }"
                        >{{
                            this.week.stats.this_week
                                .playing_weeks_season_diff_percentage / 100
                        }}%</span
                    >
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        week() {
            return this.$store.getters['week/current'];
        },
    },
};
</script>
